import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { Link as RouterLink } from 'react-router-dom';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: ${props => props.theme.columnGap};
  row-gap: ${props => props.theme.rowGap};
  width: 100%;

  ${Media.lg`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Item = styled(RouterLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Imagebox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: ${props => props.theme.margin.default};

  &:after {
    position: absolute;
    display: ${props => (props.theme.after.content ? 'block' : 'none')};
    content: '${props => props.theme.after.content}';
    bottom: 9px;
    right: -12px;
    transform: rotate(270deg);
    transform-origin: top;
    transition: 0.2s all;
    background-color: ${props => props.theme.after.backgroundColor};
    color: ${props => props.theme.after.color};
    font-family: ${props => props.theme.after.fontFamily};
    font-size: ${props => `${props.theme.after.fontSize}rem`};
    line-height: ${props => props.theme.after.lineHeight};
    font-weight: ${props => props.theme.after.fontWeight};
    padding: ${props => props.theme.after.padding};
  }

  &:hover:after {
    background-color: ${props => props.theme.after.backgroundColorOnHover};
  }
`;

export const Image = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const Text = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
`;
export const MoreLink = styled(RouterLink)`
  align-self: flex-end;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  border-radius: ${props => props.theme.borderRadius.default};
  ${props =>
    props.theme.background &&
    css`
      background: ${props => props.linkBackground || props.theme.background};
    `}
  ${props =>
    props.theme.color &&
    css`
      color: ${props => props.linkColor || props.theme.color};
    `}
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  white-space: nowrap;
  z-index: 0;
  cursor: pointer;
`;
